<template>
  <b-col class="page-column" :class="{ 'page-column--narrow': columnFitState.narrow }" :style="columnStyle">
    <template v-for="(comp, index) in this.internalFormComponents" :key="comp.uniqueTitle">
      <component
        :is="comp"
        v-if="comp"
        v-bind:items="comp.items"
        v-bind:uniqueTitle="comp.uniqueTitle"
        v-bind:formComponents="comp.formComponents"
        v-bind:columnFormat="comp.columnFormat"
        v-bind:filters="comp.filters"
        v-bind:isEditForm="comp.isEditForm"
        v-bind:userFiltering="comp.userFilteringValue"
        v-bind:pageUniqueTitle="comp.pageUniqueTitleValue"
        v-bind:componentUniqueTitle="comp.componentUniqueTitleValue"
        v-bind:fieldCounterMap="comp.fieldCounterMapValue"
        v-bind:defaultUserFilters="comp.defaultUserFiltersValue"
        v-bind:defaultUserFilterMatchMode="comp.defaultUserFilterMatchModeValue"
        v-bind:restrictUserFiltering="comp.restrictUserFilteringValue"
        v-bind:chartType="comp.chartTypeValue"
        v-bind:title="comp.titleValue"
        v-bind:realtime="comp.realtimeValue"
        v-bind:csvExport="comp.csvExportValue"
        v-bind:tableLayout="comp.tableLayoutValue"
        v-bind:searchEnabled="comp.searchEnabledValue"
        v-bind:filterButtons="comp.filterButtonsValue"
        v-bind:allowMultipleFilterButtons="comp.allowMultipleFilterButtonsValue"
        v-bind:oneCardPerRow="comp.oneCardPerRowValue"
        v-bind:cardsPerRow="comp.cardsPerRowValue"
        v-bind:detail="comp.detailValue"
        v-bind:addressColumn="comp.addressColumnValue"
        v-bind:latitudeColumn="comp.latitudeColumnValue"
        v-bind:longitudeColumn="comp.longitudeColumnValue"
        v-bind:mapStyleUrl="comp.mapStyleUrlValue"
        v-bind:dateColumn="comp.dateColumnValue"
        v-bind:titleColumn="comp.titleColumnValue"
        v-bind:descriptionColumn="comp.descriptionColumnValue"
        v-bind:recurrenceColumn="comp.recurrenceColumnValue"
        v-bind:calendarLayout="comp.calendarLayoutValue"
        v-bind:addFormUniqueTitle="comp.addFormUniqueTitleValue"
        v-bind:spreadSheetUniqueTitle="comp.spreadSheetUniqueTitleValue"
        v-bind:pivotConfig="comp.pivotConfigValue"
        v-bind:viewCode="comp.viewCodeValue"
        v-bind:viewCss="comp.viewCssValue"
        v-bind:richTextContent="comp.richTextContentValue"
        v-bind:menuItems="comp.menuItemsValue"
        v-bind:staticImageId="comp.staticImageIdValue"
        v-bind:altText="comp.altTextValue"
        v-bind:submissionRules="comp.submissionRules"
        v-bind:twoFactor="comp.twoFactorValue"
        v-bind:defaultValueRules="comp.defaultValueRules"
        v-bind:formActions="comp.formActions"
      />
    </template>
  </b-col>
</template>

<script>

import { markRaw } from 'vue'
import _ from 'lodash'
import axios from 'axios'
import Table from './table.vue'
import Carousel from './carousel.vue'
import Cards from './cards.vue'
import Maps from './maps.vue'
import Calendar from './calendar.vue'
import Form from './form.vue'
import LoginForm from './loginform.vue'
import RegisterForm from './registerform.vue'
import Chart from './chart.vue'
import Pivot from './pivot.vue'
import CustomView from './custom.vue'
import RichTextView from './richtext.vue'
import StaticImageView from './staticimage.vue'
import PageMenu from './pagemenu.vue'
import { shouldRenderView } from '../lib/view-visibility'
import { buildViewFieldModel } from '../../../shared/view-fields'
import { normalizeTableLayout } from '../../../shared/table-layout'
import { MAP_ROW_LIMIT, stampMapPoint } from '../../../shared/map-location'
import { CALENDAR_ROW_LIMIT, calendarDayKey, stampCalendarEvent } from '../../../shared/calendar-event'
import { formatAppInstant } from '../lib/app-time-zone'
import { imageCellHtml, imageDataUrl, imageFilename, imageMarkupSource } from '../../../shared/image-column'
import { displayListValue, listDisplayMap } from '../../../shared/multiselect-display'
import { cardUsesOnePerRow, cardsAcross } from '../../../shared/card-layout'
import { assignColumnFormat, columnFormatStyle } from '../../../shared/column-format'
import { columnFitMixin } from '../lib/column-fit'
import { copySubmissionConfig } from '../../../shared/submission-redirect'
import { assignPresetFilterProps } from '../lib/preset-filter-state'

// Lazy-load Row and Column to avoid circular dependencies
// column.vue <-> row2.vue and column.vue <-> column2.vue
const getComponentMap = () => ({
  table: Table,
  pivot: Pivot,
  custom: CustomView,
  cards: Cards,
  card: Cards,
  maps: Maps,
  calendar: Calendar,
  form: Form,
  login: LoginForm,
  registration: RegisterForm,
  row: require('./row2.vue').default,
  column: require('./column2.vue').default,
  carousel: Carousel,
  chart: Chart,
  richtext: RichTextView,
  staticimage: StaticImageView,
  menu: PageMenu
})

const getData = async (componentUniqueTitle) => {

}

export default {
  mixins: [columnFitMixin],
  props: ['formComponents', 'uniqueTitle', 'columnFormat'],
  data() {
    return {
      internalFormComponents: [],
      filterListeners: {}
    }
  },
  watch: {
    formComponents: {
      immediate: true,
      async handler () {

        console.log(`column formComponents handler called!`)
        console.log(this)
        console.log(this.uniqueTitle)
        console.log(this.formComponents)

        this.internalFormComponents = []
        let counter = 0
        let noUniqueTitleCounter = 0

        if (!this.formComponents) {

          return
        }

        const componentMap = getComponentMap()

        for (let component of this.formComponents) {

          if (!shouldRenderView(component)) continue

          console.log(`col1 adding component ${component.type} with placeholder ${component.placeholder} >`)
          console.log(component)

          let instantiatedComponent = _.cloneDeep(componentMap[component.type])

          console.log(`ABOUT TO TRIGGER UPDATE WITH ${component.uniqueTitle} on`)
          console.log(instantiatedComponent)

          if (!component.uniqueTitle) {

            component.uniqueTitle = `component_without_unique_title_${noUniqueTitleCounter++}`
          }

          if (!instantiatedComponent) {

            continue
          }

          // Vue 3: direct assignment instead of this.$set
          instantiatedComponent.uniqueTitle = component.uniqueTitle

          if (component.type === `form` || component.type === `login` || component.type === `registration` || component.type === `row` || component.type === `column`) {

            instantiatedComponent.formComponents = component.components
          }

          assignColumnFormat(instantiatedComponent, component)

          instantiatedComponent.title = component.title
          instantiatedComponent.titleValue = component.title || ''
          instantiatedComponent.userFilteringValue = !!component.userFiltering
          instantiatedComponent.pageUniqueTitleValue = this.routePageUniqueTitle || window.__superturbo_getPageUniqueTitle?.() || ''
          instantiatedComponent.componentUniqueTitleValue = component.uniqueTitle
          instantiatedComponent.fieldCounterMapValue = null
          instantiatedComponent.defaultUserFiltersValue = component.defaultUserFilters || []
          instantiatedComponent.defaultUserFilterMatchModeValue = component.defaultUserFilterMatchMode || 'all'
          instantiatedComponent.restrictUserFilteringValue = !!component.restrictUserFiltering
          instantiatedComponent.realtimeValue = !!component.realtime
          instantiatedComponent.csvExportValue = !!component.csvExport
          instantiatedComponent.tableLayoutValue = component
          instantiatedComponent.searchEnabledValue = component.searchEnabled === true || component.searchEnabled === 'true'
          instantiatedComponent.oneCardPerRowValue = cardUsesOnePerRow(component)
          instantiatedComponent.cardsPerRowValue = cardsAcross(component) || 0
          instantiatedComponent.addressColumnValue = component.addressColumn || ''
          instantiatedComponent.latitudeColumnValue = component.latitudeColumn || ''
          instantiatedComponent.longitudeColumnValue = component.longitudeColumn || ''
          instantiatedComponent.mapStyleUrlValue = component.mapStyleUrl || ''
          instantiatedComponent.dateColumnValue = component.dateColumn || ''
          instantiatedComponent.titleColumnValue = component.titleColumn || ''
          instantiatedComponent.descriptionColumnValue = component.descriptionColumn || ''
          instantiatedComponent.recurrenceColumnValue = component.recurrenceColumn || ''
          instantiatedComponent.calendarLayoutValue = component.calendarLayout || 'month'
          instantiatedComponent.addFormUniqueTitleValue = component.addFormUniqueTitle || ''
          instantiatedComponent.spreadSheetUniqueTitleValue = component.spreadSheet || ''
          instantiatedComponent.viewCodeValue = component.viewCode || ''
          instantiatedComponent.viewCssValue = component.viewCss || ''

          if (!instantiatedComponent.props.userFiltering) {

            instantiatedComponent.props.userFiltering = {}
          }

          instantiatedComponent.props.userFiltering.default = component.userFiltering

          if (!instantiatedComponent.props.filters) {

            instantiatedComponent.props.filters = {}
          }

          instantiatedComponent.props.filters.default = component.filters

          if (component.type === `table` || component.type === `cards` || component.type === `card` || component.type === `maps` || component.type === `calendar`) {

            console.log(`build evengt`)
            console.log(`filter-changed-${component.uniqueTitle}`)

            if (!Array.isArray(component.components)) {

              component.components = []
            }

            const fieldModel = buildViewFieldModel(component)
            const fieldCounterMap = fieldModel.fieldCounterMap

            if (component.type !== `card`) {

              const filterCallback = async (filterData) => {
                instantiatedComponent.items = await this.getDataTable(component.uniqueTitle, fieldCounterMap, component, filterData, component)
              }
              this.filterListeners[`filter-changed-${component.uniqueTitle}`] = filterCallback
            }

            console.log('YES YES YES ' + component.type)
            console.log(component)

            if (!instantiatedComponent.props.fields) {

              instantiatedComponent.props.fields = {
                default: []
              }
            }

            instantiatedComponent.props.fields.default = fieldModel.fields

            if (fieldModel.layout) {

              if (!instantiatedComponent.props.layout) {

                instantiatedComponent.props.layout = { default: null }
              }

              instantiatedComponent.props.layout.default = fieldModel.layout
            }

            console.log(this)
            console.log(`the field counter map!!!`)
            console.log(fieldCounterMap)

            instantiatedComponent.fieldCounterMapValue = fieldCounterMap

            if (component.type === `card`) {

              instantiatedComponent.searchEnabledValue = false
              instantiatedComponent.userFilteringValue = false
              instantiatedComponent.oneCardPerRowValue = true
              instantiatedComponent.detailValue = true
              instantiatedComponent.items = await this.getDetailCard(component.uniqueTitle, fieldCounterMap, component)
            } else {

              instantiatedComponent.items = await this.getDataTable(component.uniqueTitle, fieldCounterMap, undefined, undefined, component)
            }

            // [{ id: 1, test: 'asdf', links: { xyzxxxz: 'asdf' } },
            // { id: 2, test: 'asdf', links: { xyzxxxz: 'asdf' } }] //await this.getData(component.uniqueTitle)
          }

          if (component.type === `carousel`) {

            instantiatedComponent.items = await this.getDataCarousel(component.uniqueTitle)
          }

          if (component.type === `chart`) {

            instantiatedComponent.chartTypeValue = component.chartType || 'bar'
            instantiatedComponent.titleValue = component.title || ''
          }

          if (component.type === `pivot`) {

            instantiatedComponent.pivotConfigValue = {
              rowFields: component.rowFields || [],
              columnFields: component.columnFields || [],
              valueFields: component.valueFields || [],
              showSubtotals: component.showSubtotals,
              showRowGrandTotal: component.showRowGrandTotal,
              showColumnGrandTotal: component.showColumnGrandTotal
            }
          }

          if (component.type === `richtext`) {

            instantiatedComponent.richTextContentValue = component.richTextContent || ''
          }

          if (component.type === `staticimage`) {

            instantiatedComponent.staticImageIdValue = component.staticImageId || null
            instantiatedComponent.altTextValue = component.altText || ''
            instantiatedComponent.titleValue = component.title || ''
          }

          if (component.type === `menu`) {

            instantiatedComponent.menuItemsValue = _.cloneDeep(component.menuItems || [])
            instantiatedComponent.titleValue = component.title || ''
          }

          copySubmissionConfig(instantiatedComponent, component)

          if (component.type === `form`) {

            if (component.isEditForm === true) {
              instantiatedComponent.isEditForm = true
            }
          }

          //instantiatedComponent.items = await intake.getData(appSchema.pages[0].uniqueTitle, component.uniqueTitle, this.linkParent)

          console.log(`push ${component.uniqueTitle} / ${instantiatedComponent.uniqueTitle}`)
          console.log(instantiatedComponent)
          console.log(`fiuelkds`)
          //console.log(instantiatedComponent.props.fields.default)
          console.log(instantiatedComponent.items)

          assignPresetFilterProps(instantiatedComponent, component)

          this.internalFormComponents.push(markRaw(instantiatedComponent))

          console.log(`conponent filters`)
          console.log(component.filters)
          console.log(instantiatedComponent)
          continue
        }
      }
    }
  },
  computed: {
    columnStyle () {

      return columnFormatStyle(this.columnFormat) || { minWidth: '250px' }
    }
  },
  methods: {
    onSubmit (event) {

      return event.preventDefault()
    },
    filterUpdate (componentUniqueTitle, filterData) {

      const callback = this.filterListeners[`filter-changed-${componentUniqueTitle}`]
      if (callback) {
        callback(filterData)
      }
    },
    async getEditFormTable (componentUniqueTitle, fieldCounterMap, component) {

      console.log(`getEditFormTable`)
      console.log(componentUniqueTitle)

      let filters

      if (component && component.filters) {

        filters = component.filters
      }

      if (userFilters) {

        filters = userFilters
      }

      let url = `${VUE_APP_PROXY_SERVER_URL}/${this.routeAccount}/${this.$route.params.application}/pages/${this.routePageUniqueTitle || window.__superturbo_getPageUniqueTitle()}/components/${componentUniqueTitle}?limit=25`

      if (filters) {

        url += `&filters=${encodeURIComponent(JSON.stringify(filters))}`
      }

      const editAccessKey = this.routeAccessKey
      if (editAccessKey) {
        url += `&accessKey=${encodeURIComponent(editAccessKey)}`
      }

      let componentData = await axios.get(url)

      console.log('axios res')
      console.log(componentData.data)

      componentData.data = _.map(componentData.data, (row) => {

        console.log(`format r0w`)
        console.log(row)

        let newRow = {}

        for (const key of Object.keys(row)) {

          if (key.endsWith(`_filename`) || key.endsWith(`_type`)) {

            continue
          }

          let column = row[key]

          console.log(`format col`)
          console.log(column)
          console.log(`keyu`)
          console.log(key)
          console.log(fieldCounterMap[key])

          // need number or this field has no display value (like id or something)
          if (typeof fieldCounterMap[key] !== `number`) {

            continue
          }

          const imageHtml = imageCellHtml(row, key)

          if (imageHtml != null) column = imageHtml

          newRow[fieldCounterMap[key]] = column
        }

        // Preserve link data from server
        if (row._links) newRow._links = row._links
        if (row.links) newRow.links = row.links

        return newRow
      })

      console.log(`data2`)
      console.log(componentData.data)

      return componentData.data
    },
    generateFakeTableData (fieldCounterMap, locationView) {
      const sampleWords = ['Alpha', 'Bravo', 'Charlie', 'Delta', 'Echo']
      const samplePoints = [
        { lat: 37.7749, lng: -122.4194 },
        { lat: 37.8044, lng: -122.2712 },
        { lat: 37.6879, lng: -122.4702 },
        { lat: 37.5585, lng: -122.2711 },
        { lat: 37.8715, lng: -122.273 }
      ]
      const rows = []
      for (let i = 0; i < 5; i++) {
        const row = {}
        for (const [fieldName, fieldIndex] of Object.entries(fieldCounterMap || {})) {
          row[fieldIndex] = `${sampleWords[i % sampleWords.length]} ${fieldName.replace(/_/g, ' ')}`
        }
        if (locationView && locationView.type === 'maps') {
          row._lat = samplePoints[i].lat
          row._lng = samplePoints[i].lng
        }
        if (locationView && locationView.type === 'calendar') {
          const day = new Date()
          day.setDate(day.getDate() + (i - 2))
          row._calendarDate = calendarDayKey(day)
          row._calendarTitle = `${sampleWords[i % sampleWords.length]} event`
          row._calendarDescription = `Preview description ${i + 1}`
        }
        rows.push(row)
      }
      return rows
    },
    async getDataTable (componentUniqueTitle, fieldCounterMap, component, userFilterData, locationView) {

      if (window.__superturbo_preview_mode) {
        return this.generateFakeTableData(fieldCounterMap, locationView)
      }

      console.log(`getDataTable`)
      console.log(componentUniqueTitle)

      let filters

      if (component && component.filters) {

        filters = component.filters
      }

      const tableLayout = locationView && locationView.type === 'table' ? normalizeTableLayout(locationView) : null
      const rowLimit = locationView && locationView.type === 'maps'
        ? MAP_ROW_LIMIT
        : (locationView && locationView.type === 'calendar'
          ? CALENDAR_ROW_LIMIT
          : (tableLayout && tableLayout.pageSize ? tableLayout.pageSize : 25))
      let url = `${VUE_APP_PROXY_SERVER_URL}/${this.routeAccount}/${this.$route.params.application}/pages/${this.routePageUniqueTitle || window.__superturbo_getPageUniqueTitle()}/components/${componentUniqueTitle}?limit=${rowLimit}`

      if (filters) {

        url += `&filters=${encodeURIComponent(JSON.stringify(filters))}`
      }

      if (userFilterData && userFilterData.filters && userFilterData.filters.length > 0) {

        url += `&userFilters=${encodeURIComponent(JSON.stringify(userFilterData.filters))}`
        url += `&userFilterMatchMode=${encodeURIComponent(userFilterData.matchMode || 'all')}`
      }

      const accessKey = this.routeAccessKey
      if (accessKey) {
        url += `&accessKey=${encodeURIComponent(accessKey)}`
      }

      let componentData = await axios.get(url)

      return this.formatViewRows(componentData.data, fieldCounterMap, locationView)
    },
    formatViewRows (rows, fieldCounterMap, locationView) {

      const displays = listDisplayMap(locationView)

      return _.map(rows || [], (row) => {

        let newRow = {}
        let rawRow = {}

        newRow._values = row
        if (row.id !== undefined) newRow._rowId = row.id
        if (row._id !== undefined) newRow._rowId = row._id
        if (row._formatting) newRow._formatting = row._formatting

        for (const key of Object.keys(row)) {

          if (key === '_formatting' || key === '_links' || key === 'links') continue

          if (key.endsWith(`_filename`) || key.endsWith(`_type`)) {

            continue
          }

          let column = row[key]

          if (typeof fieldCounterMap[key] !== `number`) {

            continue
          }

          rawRow[fieldCounterMap[key]] = column

          const imageHtml = imageCellHtml(row, key)

          if (imageHtml != null) {

            column = imageHtml
          } else {

            const listed = displayListValue(column, displays[key])

            if (listed != null) column = listed
            else if (typeof column === 'string') column = formatAppInstant(column)
          }

          newRow[fieldCounterMap[key]] = column
        }

        if (row._links) newRow._links = row._links
        if (row.links) newRow.links = row.links

        newRow._raw = rawRow
        stampMapPoint(newRow, row, locationView)
        stampCalendarEvent(newRow, row, locationView)
        return newRow
      })
    },
    async getDetailCard (componentUniqueTitle, fieldCounterMap, locationView) {

      if (window.__superturbo_preview_mode) {

        return this.generateFakeTableData(fieldCounterMap, locationView).slice(0, 1)
      }

      const accessKey = this.routeAccessKey

      if (!accessKey) return []

      const url = `${VUE_APP_PROXY_SERVER_URL}/${this.routeAccount}/${this.$route.params.application}/pages/${this.routePageUniqueTitle || window.__superturbo_getPageUniqueTitle()}/components/${componentUniqueTitle}/accesskey/${encodeURIComponent(accessKey)}`

      try {

        const response = await axios.get(url)
        const row = response.data

        if (!row || typeof row !== 'object' || Array.isArray(row)) return []

        return this.formatViewRows([row], fieldCounterMap, locationView)
      } catch (err) {

        console.warn('Failed to load the record for this card:', err)
        return []
      }
    },
    async getDataCarousel (componentUniqueTitle) {

      if (window.__superturbo_preview_mode) {
        return [
          { caption: 'Sample Image 1', text: 'Preview slide 1', imageSource: '' },
          { caption: 'Sample Image 2', text: 'Preview slide 2', imageSource: '' }
        ]
      }

      console.log(`GET DATA CAROUSEL`)

      let carouselUrl = `${VUE_APP_PROXY_SERVER_URL}/${this.routeAccount}/${this.$route.params.application}/pages/${this.routePageUniqueTitle || window.__superturbo_getPageUniqueTitle()}/components/${componentUniqueTitle}?limit=25`

      const carouselAccessKey = this.routeAccessKey
      if (carouselAccessKey) {
        carouselUrl += `&accessKey=${encodeURIComponent(carouselAccessKey)}`
      }

      let componentData = await axios.get(carouselUrl)

      console.log('axios res')
      console.log(componentData.data)

      componentData.data = _.map(componentData.data, (row) => {

        console.log(`Cformat r0w`)
        console.log(row)

        let newRow = {}

        for (const key of Object.keys(row)) {

          if (key.endsWith(`_filename`) || key.endsWith(`_type`)) {

            continue
          }

          let column = row[key]

          console.log(`format col`)
          console.log(column)

          const imageSource = imageDataUrl(row, key) || imageMarkupSource(column)

          if (imageSource) {

            const filename = imageFilename(row, key) || row[`${key}_filename`] || ''

            return {
              caption: filename,
              text: filename,
              imageSource
            }
          }

          newRow[key] = column
        }

        return newRow
      })

      console.log(`Cdata2`)
      console.log(componentData.data)

      return componentData.data
    }
  }
}
</script>
